import React from 'react'

import SearchFieldBase, { BasicProps } from 'src/Libs/inputs/formik/SearchFieldBase'
import { useFilteredUserOptions } from '../hooks/use-filtered-users-options'

interface Props extends BasicProps {
  additionalFilter?: string
}

/**
 * Input field for users names that asynchroniously fetches data filtered by the input
 */
const UsersSearch = (props: Props): React.ReactElement => {
  const { fetchFilteredUsers } = useFilteredUserOptions(props.additionalFilter)

  return <SearchFieldBase {...props} fetchFilteredValues={fetchFilteredUsers} />
}

export default UsersSearch
